import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

const HymnStyledComponents = {
  StyledDivider: styled(Divider)({
    width: '400px',
    margin: 'auto'
  }),
  ArrowRightWrapper: styled(Box)(({ theme }) => ({
    position: 'fixed',
    top: '50%',
    right: '20px',
    width: '80px',
    height: '80px',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      color: theme.palette.text.primary
    }
  })),
  ArrowLeftWrapper: styled(Box)(({ theme }) => ({
    position: 'fixed',
    top: '50%',
    left: '20px',
    width: '80px',
    height: '80px',
    cursor: 'pointer',
    color: theme.palette.text.secondary,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    ':hover': {
      color: theme.palette.text.primary
    },
    ':focus-visible': {
      outline: 'none'
    }
  })),
  ArrowRightIcon: styled(ArrowForwardIosIcon)({
    width: '50px',
    height: '50px',
    ':focus': {
      outline: 'none'
    }
  }),
  ArrowLeftIcon: styled(ArrowBackIosIcon)({
    width: '50px',
    height: '50px',
    ':focus': {
      outline: 'none'
    }
  }),
  MobArrowRightIcon: styled(ArrowForwardIosIcon)(({ theme }) => ({
    position: 'fixed',
    top: '50%',
    right: '20px',
    width: '50px',
    height: '50px',
    color: theme.palette.text.secondary,
    opacity: '0.2'
  })),
  MobArrowLeftIcon: styled(ArrowBackIosIcon)(({ theme }) => ({
    position: 'fixed',
    top: '50%',
    left: '20px',
    width: '50px',
    height: '50px',
    color: theme.palette.text.secondary,
    opacity: '0.2'
  }))
};

export default HymnStyledComponents;
